// cfgactions

const state = {
	cfgactions: {},
	
};

export default state;